import React from 'react';

/**
 * Custom brand SVG icons (outline) per CRAFTFOOD brandbook.
 * Stroke-only to match brand values icon style.
 */

const baseProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.4,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export const LeafIcon = (props) => (
  <svg {...baseProps} {...props}>
    <path d="M4 19c8 0 14-6 14-14 0-1 0-2-.5-3C7.5 4 4 10 4 17v2z" />
    <path d="M4 19c4-8 8-12 14-14" />
  </svg>
);

export const HeartIcon = (props) => (
  <svg {...baseProps} {...props}>
    <path d="M12 21s-7-4.5-7-10a4.5 4.5 0 0 1 8.5-2A4.5 4.5 0 0 1 19 11c0 5.5-7 10-7 10z" />
  </svg>
);

export const MedalIcon = (props) => (
  <svg {...baseProps} {...props}>
    <circle cx="12" cy="14" r="6" />
    <path d="M9 8L7 3h10l-2 5" />
    <path d="M10 14l1.5 1.5L15 12" />
  </svg>
);

export const PeopleIcon = (props) => (
  <svg {...baseProps} {...props}>
    <circle cx="9" cy="8" r="3" />
    <circle cx="16" cy="9" r="2.5" />
    <path d="M3 19c0-3 3-5 6-5s6 2 6 5" />
    <path d="M14 19c0-2 2-3.5 5-3.5" />
  </svg>
);

export const NoYeastIcon = (props) => (
  <svg {...baseProps} {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M5 5l14 14" />
    <circle cx="9" cy="10" r="1" />
    <circle cx="14" cy="12" r="1" />
    <circle cx="11" cy="15" r="1" />
  </svg>
);

export const NoPreservativesIcon = (props) => (
  <svg {...baseProps} {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M5 5l14 14" />
    <rect x="9" y="8" width="6" height="8" rx="1" />
  </svg>
);

export const LessSugarIcon = (props) => (
  <svg {...baseProps} {...props}>
    <rect x="4" y="9" width="16" height="9" rx="1" />
    <path d="M8 9V6h8v3" />
    <path d="M3 13l3-1m12 0l3 1" strokeDasharray="2 2" />
  </svg>
);

export const CleanIcon = (props) => (
  <svg {...baseProps} {...props}>
    <path d="M12 3l2 4 4 1-2 3v4l-4-1-4 1v-4l-2-3 4-1z" />
  </svg>
);
